import { DataBaseModelInterface } from '@solcre-org/core';
import { PortTariffLineUnitTypes } from '../enums/port-tariff-line-unit-types.enum';
import { PortTariffLineVesselProperties } from '../enums/port-tariff-line-vessel-properties.enum';
import { PortTariffLineTypes } from '../enums/port-tariff-line-types.enum';
import { PortTariffLineExpenseCategories } from '../enums/port-tariff-line-expense-category.enum';
import { PortTariffLineOperationDirections } from '../enums/port-tariff-line-operation-direction.enum';

export type TariffLineKind = PortTariffLineTypes;

export class PortTariffLineFormModel implements DataBaseModelInterface {
  constructor(
    public concept: string = '',
    public sortOrder: number | null = 1,
    public lineType: TariffLineKind = PortTariffLineTypes.STANDARD,
    public rateValue: string | null = null,
    public unitType: PortTariffLineUnitTypes | string = PortTariffLineUnitTypes.FIXED,
    public vesselProperty: PortTariffLineVesselProperties | string = PortTariffLineVesselProperties.NONE,
    public expenseCategory: PortTariffLineExpenseCategories | string = PortTariffLineExpenseCategories.PORT,
    public operationDirection: PortTariffLineOperationDirections | string = PortTariffLineOperationDirections.BOTH,
    public cargoType: string | null = null,
    public applicableVessel: string | null = null,
    public quantityMultiplier: string = '1.0000',
    public ot1RateValue: string | null = null,
    public ot1UnitType: PortTariffLineUnitTypes | string = PortTariffLineUnitTypes.FIXED,
    public ot1VesselProperty: PortTariffLineVesselProperties | string = PortTariffLineVesselProperties.NONE,
    public ot1CargoType: string | null = null,
    public ot1QuantityMultiplier: string = '1.0000',
    public ot2RateValue: string | null = null,
    public ot2UnitType: PortTariffLineUnitTypes | string = PortTariffLineUnitTypes.FIXED,
    public ot2VesselProperty: PortTariffLineVesselProperties | string = PortTariffLineVesselProperties.NONE,
    public ot2CargoType: string | null = null,
    public ot2QuantityMultiplier: string = '1.0000'
  ) {}

  fromJSON(json: any): PortTariffLineFormModel {
    if (json) {
      this.concept = json.concept ?? '';
      this.sortOrder = json.sortOrder ?? 1;
      this.lineType = json.lineType === PortTariffLineTypes.TAX ? PortTariffLineTypes.TAX : PortTariffLineTypes.STANDARD;
      this.rateValue = json.rateValue ?? null;
      this.unitType = json.unitType ?? PortTariffLineUnitTypes.FIXED;
      this.vesselProperty = json.vesselProperty ?? PortTariffLineVesselProperties.NONE;
      this.expenseCategory = json.expenseCategory ?? PortTariffLineExpenseCategories.PORT;
      this.operationDirection = json.operationDirection ?? PortTariffLineOperationDirections.BOTH;
      this.cargoType = json.cargoType ?? null;
      this.applicableVessel = json.applicableVessel ?? null;
      this.quantityMultiplier = json.quantityMultiplier ?? '1.0000';

      this.ot1RateValue = json.ot1RateValue ?? null;
      this.ot1UnitType = json.ot1UnitType ?? PortTariffLineUnitTypes.FIXED;
      this.ot1VesselProperty = json.ot1VesselProperty ?? PortTariffLineVesselProperties.NONE;
      this.ot1CargoType = json.ot1CargoType ?? null;
      this.ot1QuantityMultiplier = json.ot1QuantityMultiplier ?? '1.0000';

      this.ot2RateValue = json.ot2RateValue ?? null;
      this.ot2UnitType = json.ot2UnitType ?? PortTariffLineUnitTypes.FIXED;
      this.ot2VesselProperty = json.ot2VesselProperty ?? PortTariffLineVesselProperties.NONE;
      this.ot2CargoType = json.ot2CargoType ?? null;
      this.ot2QuantityMultiplier = json.ot2QuantityMultiplier ?? '1.0000';
    }
    return this;
  }

  toJSON() {
    return {
      concept: this.concept,
      sortOrder: this.sortOrder,
      lineType: this.lineType,
      rateValue: this.rateValue,
      unitType: this.unitType,
      vesselProperty: this.vesselProperty,
      expenseCategory: this.expenseCategory,
      operationDirection: this.operationDirection,
      cargoType: this.cargoType,
      applicableVessel: this.applicableVessel,
      quantityMultiplier: this.quantityMultiplier,
      ot1RateValue: this.ot1RateValue,
      ot1UnitType: this.ot1UnitType,
      ot1VesselProperty: this.ot1VesselProperty,
      ot1CargoType: this.ot1CargoType,
      ot1QuantityMultiplier: this.ot1QuantityMultiplier,
      ot2RateValue: this.ot2RateValue,
      ot2UnitType: this.ot2UnitType,
      ot2VesselProperty: this.ot2VesselProperty,
      ot2CargoType: this.ot2CargoType,
      ot2QuantityMultiplier: this.ot2QuantityMultiplier,
    };
  }

  getId() {
    return this.concept;
  }

  getReference() {
    return this.concept;
  }
}
